import { store } from 'Store/Store';
import { authorizedUser } from 'Store/Selectors/AuthSelector';

const checkPrivilegeAccess = (privilege) => {
    const { privileges } = authorizedUser(store.getState());
    return privileges.includes(privilege);
}

export default checkPrivilegeAccess;